import axios from "axios";
import { SERVER_URL } from "../config/config";

class OrderService {
  private static serverURL = SERVER_URL;

  public static async getOrderList(search: any = {}) {
    let parameteres = search;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async getOrder(Id: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/${Id}`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async createOrder(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createOrder", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async createOrderTran(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createORder", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/createordertran`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async updateMembershipOrder(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("updateOrder", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/${body.OrderId}/membership`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async createPaymentTran(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createPayment", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/createpaymenttran`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async exportOrders(search: any = {}) {
    let parameteres = search;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      params: parameteres,
      responseType: 'blob' as const
    };
    const apiUrl = `${this.serverURL}/api/order/export`;
    const response = await axios.get(apiUrl, axiosConfig);
    return response;
  }

  public static async createPayment(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createPayment", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/createpayment`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async createPaymentWithOrderId(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createPayment", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/createPaymentWithOrderId`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async createMembershipPayment(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createPayment", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/createmembershippayment`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async createGuestOrder(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createOrder", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/guest`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async updateOrder(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createOrder", body);
    console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/event`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async getOrderByMemberId(memberId: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/active-order/member/${memberId}`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response-orderbymemberID", apiUrl, "-", response);
    return response;
  }

  public static async getFutureOrderByMemberId(memberId: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/future-active-order/member/${memberId}`;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("response-orderbymemberID", apiUrl, "-", response);
    return response;
  }

  public static async cancelOrder(orderId: number) {
    console.log("cancelOrder Called");
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    try {
      const apiUrl = `${this.serverURL}/api/order/cancel`;
      const payload = { orderId };
      const response = await axios.put(apiUrl, payload, axiosConfig);
      console.log("response-cancelORder", apiUrl, "-", response);
      return response;
    } catch (error) {
      console.error("Error in cancelOrder:", error);
      throw error; // Propagate the error so it can be caught by the calling function
    }
  }
}

export default OrderService;
